import { TextField, styled } from '@mui/material';
import { common, grey, primary, secondary, text } from 'assets/colors/colors';
import { CSSProperties } from 'react';

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'aligncenter' && prop !== 'hasError',
})<{
  aligncenter?: boolean;
  hasError?: boolean;
}>(({ aligncenter, hasError }) => ({
  '& .MuiOutlinedInput-input': {
    textAlign: aligncenter ? 'center' : 'left',
    borderRadius: '0.25rem',
    '&::placeholder': {
      textTransform: 'none',
      opacity: 1,
      color: grey.g500,
    },
  },
  '& .MuiInputBase-root': {
    color: 'inherit',
  },
  ...(hasError && {
    '& .MuiInputBase-root': { color: 'red !important' },
    '& .MuiInputAdornment-positionStart': { color: 'red !important' },
    '& .MuiTypography-colorTextSecondary': { color: 'red !important' },
  }),

  '& .MuiInputLabel-root': {
    transform: 'translate(14px, 14px) scale(0.75) !important',
    top: -5,
    left: 0,
    transformOrigin: 'top left',
    color: hasError ? 'red !important' : `${text.secondary} !important`,
    fontSize: '18px !important',
  },
  '& .MuiInputLabel-shrink': {
    transform: 'translate(14px, -2px) scale(0.75) !important',
    color: hasError ? 'red !important' : `${text.secondary} !important`,
    fontSize: '14px !important',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: hasError ? 'red !important' : primary.border,
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${secondary.main} !important`,
  },
  '& .Mui-focused': {
    color: primary.main,
  },
  '&::placeholder': {
    fontSize: '20px', // Adjust the font size as needed
  },
  '& .css-1kaq46u-MuiFormLabel-root-MuiInputLabel-root.Mui-focused': {
    color: 'inherit !important',
  },
  // style for disabled input
  '& .Mui-disabled': {
    backgroundColor: grey.g70,
    borderColor: common.icon,
  },
}));

export const startAdornmentStyle: CSSProperties = {
  marginRight: 0,
};

export const errorIconStyle: CSSProperties = {
  color: 'red',
  margin: '8px 0px 0px 2px',
};
